/**
 * Длина имени/фамилии при регистрации: пробельные символы не учитываются
 * (требование «минимум 2 символа» — только непробельные).
 */
export function registerNameSignificantLength(s) {
  return String(s || '').replace(/\s/g, '').length;
}
